
import Vue from "vue";
import blogData from "@/data/BlogData.ts";

export default Vue.extend({
  name: "Blog",
  data() {
    return { posts: blogData };
  }
});
